import React from "react"

import { SelectOption } from "shared/types/Select"

import { ProductFilterFormData } from "entities/products/types/ProductFilter"

import { ProductFilterChipListView } from "./ProductFilterChipListView"
import { useProductFilterChipListViewModel } from "./model/useProductFilterChipListViewModel"

export interface ProductFilterChipListProps {
  filterState: ProductFilterFormData
  onChange: (formData: ProductFilterFormData) => void
  productGroupOptions?: SelectOption<string>[]
}

export const ProductFilterChipList = React.memo(
  (props: ProductFilterChipListProps) => {
    return (
      <ProductFilterChipListView
        {...useProductFilterChipListViewModel(props)}
      />
    )
  }
)

ProductFilterChipList.displayName = "ProductFilterChipList"
